import { constants } from "@qgiv/core-js";
import { useFormikContext } from "formik";
import { useSelector } from "react-redux";
import { selectPaymentData } from "../redux/slices/formSettingsSlice";
import { selectHasCompletedPayPalAuthorizationFlow } from "../redux/slices/appSettingsSlice";

/**
 * @description Hook that returns PayPal data, must be used within a Formik Form
 * @returns {boolean} displayPayPalSDKScriptProvider
 */
const useDisplayPayPalSDKScriptProvider = () => {
    const {
        ENUMS: { PaymentType },
    } = constants;

    const formikContext = useFormikContext();
    const { values = {} } = formikContext;
    const { Payment_Type = 0 } = values;

    const paymentData = useSelector(selectPaymentData);

    const hasCompletedPayPalAuthorizationFlow = useSelector(
        selectHasCompletedPayPalAuthorizationFlow,
    );
    const { enablePaypalPayments = false } = paymentData;

    const displayPayPalSDKScriptProvider =
        enablePaypalPayments &&
        Payment_Type !== PaymentType.APPLEPAY &&
        !hasCompletedPayPalAuthorizationFlow;

    return displayPayPalSDKScriptProvider;
};

export default useDisplayPayPalSDKScriptProvider;
